export enum SocketIOCommandsEnum {
  Authentication = 'socketIO:authentication',
}
